import { app } from "./app";
import { getFunctions as getFuncs, httpsCallable as callable } from "firebase/functions";

let functions;

const getFunctions = () => {
  if (functions) return functions;

  functions = getFuncs(app, 'europe-west1');

  // // Uncomment and import emulator function to use local functions
  // // Replace host with local IP to test with other device
  // connectFunctionsEmulator(_functions, 'localhost', 5001);

  return functions;
};

export const httpsCallable = name => callable(getFunctions(), name);